import { render, staticRenderFns } from "./search-price-setting.vue?vue&type=template&id=415a30f0&"
import script from "./search-price-setting.vue?vue&type=script&lang=ts&"
export * from "./search-price-setting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports